import React, { useEffect, useState } from 'react'
import './Home.css'
import myResSnacks from '../images/my-res-snacks.jpg'
import myResFood from '../images/food-my-res.jpg'
import myResDrink from '../images/tea-my-res.jpg'
import { Link } from 'react-router-dom'
import { useAuthContext } from '../hooks/useAuthContext'

const Home = () => {
  const { user } = useAuthContext()
  return (
    <>
      <h3>Welcome {user && <span>{user.name}</span> } {!user && <span>Guest</span> }</h3>
      <div className="container">
          <Link to={'/snacks'} className="item item1">
              <img src={myResSnacks} alt="" />
              <h2>SNACKS</h2>
              <p>Chill.... Relax.... Enjoy....</p>
          </Link>
          <Link to={'/food'} className="item item2">
          <img src={myResFood} alt="" />
              <h2>FOOD</h2>
              <p>Nourish Yourself.....</p>
          </Link>
          <Link to={'/drinks'} className="item item3">
          <img src={myResDrink} alt="" />
              <h2>BEVERAGES</h2>
              <p>'Hot' n 'Cool'</p>
          </Link>
      </div>
    </>
  )
}

export default Home